/**
 *  系统基础配置，常用于开发过程中的一些动态配置，方便调试和开发
 *  例如：是否开启接口加解密数据
 * todo 【注意】：发布时请留意修改此处配置！！！
 */


/**
 * 是否开启前端接口加密
 * @type {boolean} true 开启，false 关闭
 */
export const OpenApiEncrypt = true


